import {createContext} from 'react';

const dientesContext = createContext();

export default dientesContext;